import React, {Fragment} from "react";
import ListView from "../../../components/ContentDisplay/ListView";
import AddGroup from "../../../components/Modal/AddGroup";
import DeleteModal from "../../../components/Modal/DeleteModal";
import GroupCard from "./groupCard";
import {useGroupsSearchOptions} from "./useGroupsSearchOptions";
import {useGroupTableActions} from "./useGroupTableActions";
import {useGroupTableData} from "./useGroupTableData";
import {ACTIONS_LIST, LIST_HEADERS, PERMS_FOR_ACTIONS} from "./groupTable.constants";
import "./group.scss";

const GroupsTable = () => {
  const {searchOptions} = useGroupsSearchOptions();
  const {fetchAfterDelete, groups, groupsTotalCount, handleSearch, paginationConfig} =
    useGroupTableData();
  const {
    closeDeleteModal,
    closeEditModal,
    handleActionSelection,
    handleDelete,
    isDeleteModalOpen,
    isEditModalOpen,
    selectedRow,
  } = useGroupTableActions(fetchAfterDelete);

  return (
    <Fragment>
      {isEditModalOpen && (
        <AddGroup data={selectedRow} onCancel={closeEditModal} open={isEditModalOpen} />
      )}
      {isDeleteModalOpen && (
        <DeleteModal
          header={"Delete Group"}
          modalBody={"Are you sure you want to delete this group ?"}
          onClose={closeDeleteModal}
          onDelete={handleDelete}
          open={isDeleteModalOpen}
        />
      )}
      <div className="table-container">
        <ListView
          listItems={groups}
          listHeaders={LIST_HEADERS}
          onSelectAction={handleActionSelection}
          withActions
          actionsList={ACTIONS_LIST}
          permsForActions={PERMS_FOR_ACTIONS}
          totalCount={groupsTotalCount}
          withPagination={paginationConfig}
          withSearchQuery={true}
          searchPlaceHolder={"Filter Groups"}
          searchOptions={searchOptions}
          handleSearch={handleSearch}
          cardContent={GroupCard}
        />
      </div>
    </Fragment>
  );
};

export default GroupsTable;
